import { render, staticRenderFns } from "./ExpiredCartModal.vue?vue&type=template&id=5c6200f6"
import script from "./ExpiredCartModal.vue?vue&type=script&lang=js"
export * from "./ExpiredCartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports